import 'regenerator-runtime/runtime';
import {
  call, put, fork, takeEvery,
} from 'redux-saga/effects';
import { parseError } from 'logic/helpers';
import api from 'api';
import { postConversationTagsRequest } from 'actions/conversation';
import * as actionCreators from './actionCreators';
import * as actions from './actions';

function* fetchTagsRequest(req) {
  try {
    const list = yield call(api.fetchTags.bind(null, req.payload));

    yield put(actionCreators.fetchTagsSuccess({ list }));
  } catch (e) {
    yield put(actionCreators.fetchTagsFailure(parseError(e)));
  }
}

function* postTag(req) {
  try {
    const { id, tag, tags } = req.payload;
    const result = yield call(api.postTag.bind(null, { tag }));
    const newTags = tags;
    newTags[newTags.length - 1] = { value: result.id, label: result.tag };

    yield put(actionCreators.postTagSuccess({ result }));
    yield put(postConversationTagsRequest({ id, tags: newTags }));
  } catch (e) {
    yield put(actionCreators.postTagFailure(parseError(e)));
  }
}

export default [
  fork(takeEvery, actions.FETCH_TAGS_REQUEST, fetchTagsRequest),
  fork(takeEvery, actions.POST_TAG_REQUEST, postTag),
];
